module.exports = __webpack_public_path__ + "img/showMore.b0876250.svg";